import React from 'react';

const WorkHeader = ({ title, subtitle, badges, skills }) => {

  return (
    <div>
      {/* <div className="flex flex-wrap items-center gap-4 mb-6">
        {badges.map((badge, index) => (
          <span 
            key={index}
            className={`badge ${getBadgeColor(badge.color)} text-white border-none`}
          >
            {badge.text}
          </span>
        ))}
      </div> */}
      <h1 className="text-4xl lg:text-5xl font-bold mb-4">{title}</h1>
      <p className="text-lg text-base-content/80 font-light mb-6">
        {subtitle}
      </p>
      
      {skills && skills.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {skills.map((skill, index) => (
            <code
              key={index}
              className="px-2 py-1 rounded bg-gray-100 text-black border border-gray-200"
            >
              {skill}
            </code>
          ))}
        </div>
      )}
    </div>
  );
};

export default WorkHeader; 